<template>
  <!-- 购物车 -->
  <div class="index-container" v-loading="loading">
    <div class="index-content">
      <div class="nav-box">
        首页 > 柏瑞康书斋 > 购物车
        <span>> 结算</span>
      </div>
      <div class="shop-content">
        <div class="address-box">
          <span @click="addAddress">
            <div class="icon-box">+</div>新增收货地址
          </span>
          <span class="address" @click="lookAddress">地址簿</span>
        </div>
        <div class="address-info" v-if="addressInfo.receive_name">
          <div>{{addressInfo.receive_name + '—' + addressInfo.receive_mobile}}</div>
          {{addressInfo.province + addressInfo.city + addressInfo.area + addressInfo.address}}
        </div>
        <div class="order-box">
          订单编号：{{order_sn}}
          <!-- <span>下单日期：2021.10.10 19:1</span> -->
        </div>
        <div class="shop-list-box" v-for="(item,index) in shopList" :key="'shop'+index">
          <div class="shop-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.thumb + ')' }"></div>
          <div class="shop-name">{{item.goods_name}}</div>
          <div class="shop-type">规格：全集</div>
          <div class="shop-num">{{item.goods_number}}</div>
          <div class="shop-price">¥{{item.goods_price}}</div>
        </div>
        <div class="pay-text">选择支付方式</div>
        <div class="pay-type-box">
          <div
            class="type-list"
            :class="activeName === item.name?'active-type':''"
            v-for="(item,index) in typeList"
            :key="'pay' + index"
            @click="payTypeSelect(item)"
          >
            <div class="active-img" :style="{ backgroundImage: 'url( ' + activeImg + ')' }"></div>
            <i class="iconfont-icon" :class="item.icon"></i>
            {{item.name}}
          </div>
        </div>
        <div class="pay-text">优惠券</div>
        <el-radio-group v-model="isUseSale">
          <el-radio :label="true">不使用</el-radio>
          <el-radio :label="false">选择优惠券</el-radio>
        </el-radio-group>
        <div class="quan-content" v-if="!isUseSale">
          <!-- :style="{ backgroundImage: 'url( ' + quanImg + ')' }" -->
          <template v-if="quanList && quanList.length > 0">
            <div class="q-list" v-for="(item,index) in quanList" :key="index + 'q'">
              <div class="price">
                ¥
                <span>{{item.coupon_money}}</span>
              </div>
              <div class="text">{{item.coupon_title}}</div>
              <el-checkbox
                @change="isCheckChange(item.isChecked, index)"
                class="check"
                :checked="item.isChecked"
              ></el-checkbox>
            </div>
          </template>
          <div v-else class="no-text">暂无优惠券</div>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="bottom-box">
        <div class="b-flex">
          <div class="select-box">
            <span>{{totalNum}}</span> 件商品
          </div>
          <div class="price-box">
            合计
            <span>¥{{totalPrice}}</span>
          </div>
          <div class="settle-button" @click="submitOrder">立即下单</div>
        </div>
      </div>
    </div>
    <el-dialog
      class="form-box"
      :close-on-click-modal="false"
      :visible.sync="addressVisible"
      width="580PX"
    >
      <div class="form-title">地址薄</div>
      <div class="add-text" @click="addAddress">+ 新增地址</div>
      <div class="address-box">
        <div
          class="address-list"
          :class="item.is_default === 1?'address-active':''"
          v-for="(item,index) in addressList"
          :key="index"
        >
          <i class="el-icon-edit-outline" @click="editAddress(item)"></i>
          <div class="l-name" @click="selectAddress(item,index)">
            {{item.receive_name}}
            <span>{{item.receive_mobile}}</span>
          </div>
          <div class="l-addres">{{item.province + item.city + item.area + item.address}}</div>
          <div class="set">
            <el-radio @change="is_defaultChange(item)" v-model="item.is_default" :label="1">设为默认地址</el-radio>
            <!-- <i class="el-icon-full-screen"></i>设为默认地址 -->
          </div>
          <div class="del-text" @click.stop="deleteAddress(item,index)">删除</div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="page_size"
        :total="listTotal"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-dialog>
    <!-- 添加地址 -->
    <el-dialog
      class="form-box"
      :close-on-click-modal="false"
      :visible.sync="addVisible"
      width="580PX"
      @close="addressClose"
    >
      <div class="form-title">{{addTitle}}</div>
      <div class="info-list">
        <span>收件人姓名：</span>
        <el-input v-model="info.receive_name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="info-list">
        <span>收件人电话：</span>
        <el-input v-model="info.receive_mobile" placeholder="请输入电话号码"></el-input>
      </div>
      <div class="info-list">
        <span>收件人地址：</span>
        <el-cascader
          :props="props"
          @change="nativeChange"
          :options="nativeList"
          v-model="native_place"
          placeholder="请选择省/市/区/街道"
        ></el-cascader>
      </div>
      <div class="info-list">
        <span>详细地址：</span>
        <el-input
          v-model="info.address"
          placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"
          resize="none"
          type="textarea"
        ></el-input>
      </div>
      <!-- <el-radio v-model="info.is_default" :label="info.is_default">设为默认地址</el-radio> -->
      <div class="confirm-button" @click="confirmAdd">确定</div>
    </el-dialog>
    <el-dialog
      class="form-box"
      :visible.sync="infoVisible"
      :close-on-click-modal="false"
      width="700PX"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box first-box">
        <div class="t-title">商品名称：{{wayInfo.order_name}}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{wayInfo.order_amount}}</span>
        </div>
      </div>
      <div
        class="code-img"
        :style="{ backgroundImage: 'url( ' + imgUrl +  wayInfo['pay_url']+ ')' }"
      ></div>
      <div class="text-box">
        <div class="t-text">流水号：{{wayInfo.order_sn}}</div>
        <div class="t-text">付款日期：{{wayInfo.create_time}}</div>
      </div>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
    <!-- 付款信息2 -->
    <el-dialog
      class="form-box"
      :visible.sync="infoTwoVisible"
      width="700PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box">
        <div class="t-title">商品名称：{{wayInfo.order_name}}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{wayInfo.order_amount}}</span>
        </div>
      </div>
      <div class="text-box">
        <div class="t-text">流水号：{{wayInfo.order_sn}}</div>
        <div class="t-text">付款日期：{{wayInfo.create_time}}</div>
      </div>
      <div class="way-title">收款信息</div>
      <div class="money-box">
        <div class="money-info">
          公司名称：
          <span>{{wayInfo.company_name}}</span>
        </div>
        <div class="money-info">
          开户银行：
          <span>{{wayInfo.company_bank}}</span>
        </div>
        <div class="money-info">
          收款账号：
          <span>{{wayInfo.company_no}}</span>
        </div>
      </div>
      <template>
        <div class="way-title">付款凭证</div>
        <div class="tip-text">*请打款到指定收款账号并上传支付凭证截图</div>
        <el-upload
          :action="uploadUrl"
          list-type="picture-card"
          :on-remove="handleRemove"
          :on-success="successUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </template>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
  </div>
</template>
<script>
import selectImg from '@/assets/img/gouxuan_bg.png';
import quanImg from '@/assets/img/quan.png';
import api from '../api/api';
import { upload_url } from '../api/index';
import { imgUrl } from '../api/index';

export default {
  name: 'shoppingPay',
  data() {
    return {
      quanImg: quanImg,
      imgUrl: imgUrl,
      activeImg: selectImg,
      shopList: [],
      typeList: [
        // 付款方式
        {
          icon: 'icon-weixinfukuan',
          name: '微信支付',
          id: 2
        },
        {
          icon: 'icon-zhifubao',
          name: '支付宝支付',
          id: 1
        },
        {
          icon: 'icon-duigongzhuanzhang',
          name: '对公转账',
          id: 3
        },
        {
          icon: 'icon-xianjinzhifu',
          name: '现金支付',
          id: 4
        }
      ],
      activeName: '',
      isUseSale: true,
      order_sn: '',
      totalPrice: 0,
      totalNum: 0,
      pay_type: '',
      addressVisible: false,
      addressList: [],
      addVisible: false,
      nativeList: [],
      native_place: '',
      info: {
        receive_name: '',
        receive_mobile: '',
        province: '',
        city: '',
        area: '',
        address: '',
        is_default: ''
      },
      props: {
        value: 'area_name',
        label: 'area_name',
        children: 'child'
      },
      addTitle: '添加收货地址',
      addressActive: 0,
      address_id: '',
      addressInfo: {
        receive_name: '',
        receive_mobile: '',
        province: '',
        city: '',
        area: '',
        address: ''
      },
      nullAdress: {
        receive_name: '',
        receive_mobile: '',
        province: '',
        city: '',
        area: '',
        address: ''
      },
      infoTwoVisible: false,
      uploadUrl: upload_url, // 上传地址
      wayInfo: {},
      fileList: [],
      pay_img: '',
      haveOrderId: '',
      infoVisible: false,
      loading: false,
      listTotal: 0,
      orderDetail: {},
      page_size: 5,
      page_index: 1,
      quanList: [],
      checkList: [],
      coupon_id: ''
    };
  },
  computed: {},
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    const value = this.$route.query;
    if (value.order_sn) {
      this.order_sn = value.order_sn;
      this.getOrderDetail();
    }
    if (value.id) {
      this.getDetail(value.id);
      this.detailId = value.id;
    //   this.getGoodOrder();
    }
    this.getAddressList();
    this.getProvince();
  },
  methods: {
    isCheckChange(val, index) {
      console.log(val);
      let arr = this.quanList;
      arr.map(ele => {
        ele.isChecked = false;
      });
      arr[index].isChecked = true;
      this.quanList = [];
      this.$nextTick(() => {
        this.quanList = arr;
      });
      this.coupon_id = arr[index].coupon_id;
      console.log(this.coupon_id);
    },
    // 设置默认地址
    is_defaultChange(item) {
      console.log(item);
      api.editAddress(item).then(res => {
        if (res.result) {
          this.$message.success('编辑成功！');
          this.native_place = '';
          Object.keys(this.info).forEach(key => (this.info[key] = ''));
          this.getAddressList();
          this.addVisible = false;
        } else {
          this.$message.warning('编辑失败！');
        }
      });
    },
    addressClose() {
      this.native_place = '';
      Object.keys(this.info).forEach(key => (this.info[key] = ''));
      this.getAddressList();
    },
    //   获取订单详情
    getOrderDetail() {
      api.getOrderDetail({ order_sn: this.order_sn }).then(res => {
        if (res.result) {
          this.orderDetail = res.result;
          this.shopList = res.result.goods;
          this.totalPrice = res.result.order_amount;
          this.totalNum = res.result.order_num;
          this.quanList = res.result.order_coupon;
          this.quanList.map(ele => {
            ele.isChecked = false;
          });
        }
      });
    },
    // 已支付
    havePay() {
      if (this.infoVisible === true) {
        this.infoVisible = false;
        this.$router.replace({ path: '/commodityOrder?name=商品订单' });
        return;
      }
      if (this.pay_type === 3 || this.pay_type === 4) {
        //   this.infoTwoVisible = false;
        //   return;
        if (!this.pay_img) {
          this.$message.warning('请上传支付凭证！');
        } else {
          this.submitImg();
        }
      }
    },
    submitImg() {
      api
        .submitOrder({
          order_sn: this.wayInfo.order_sn,
          pay_img: this.pay_img,
          address_id: this.address_id,
          pay_type: this.pay_type
        })
        .then(res => {
          if (res.result) {
            this.$message.success('提交成功！');
            this.infoTwoVisible = false;
            this.$router.replace({ path: '/commodityOrder?name=商品订单' });
          } else {
            this.$message.warning('提交失败！');
          }
        });
    },
    // 凭证移除
    handleRemove(file) {
      this.pay_img = '';
    },
    // 上传成功
    successUpload(res, file, fileList) {
      if (res.result) {
        this.pay_img = res.result;
        this.$message.success('上传成功！');
      } else {
        this.$message.warning('上传失败！');
      }
    },
    //   获取详情
    getDetail(id) {
      api.getShopDetail({ uuid: id }).then(res => {
        if (res.result) {
          this.shopList[0] = res.result;
          this.shopList[0].num = 1;
          this.wayInfo = res.result;
          this.getTotalPrice();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    getTotalPrice() {
      let total = 0;
      for (let i = 0; i < this.shopList.length; i++) {
        total += this.shopList[i].price * this.shopList[i].num;
      }
      this.totalPrice = total;
      // return total;
    },
    // 获取订单编号
    getGoodOrder() {
      const params = {
        goods: this.detailId,
        create_type: 1
      };
      api.getGoodOrder(params).then(res => {
        if (res.result) {
          this.order_sn = res.result.order_sn;
          this.getOrderDetail();
        }
      });
    },
    // 下单
    submitOrder() {
      if (!this.address_id) {
        this.$message.warning('请选择收货地址！');
      } else if (!this.pay_type) {
        this.$message.warning('请选择付款方式！');
      } else {
        const params = {
          address_id: this.address_id,
          pay_type: this.pay_type,
          coupon_id: this.coupon_id,
          pay_img: '',
          order_sn: this.order_sn
        };
        api.submitOrder(params).then(res => {
          if (res.result) {
            this.haveOrderId = res.result.order_sn;
            this.loading = true;
            this.commodityPay();
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    commodityPay() {
      api.commodityPay({ order_sn: this.haveOrderId }).then(res => {
        if (res.result) {
          this.wayInfo = res.result;
          if (this.pay_type == 3 || this.pay_type == 4) {
            this.infoTwoVisible = true;
          } else {
            this.infoVisible = true;
          }
        }
        this.loading = false;
      });
    },
    payTypeSelect(item) {
      this.activeName = item.name;
      this.pay_type = item.id;
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getAddressList();
    },
    // 获取地址列表
    getAddressList() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size
      };
      api.getAddressList(params).then(res => {
        console.log(res);
        if (res.result) {
          this.addressList = res.result.data;
          this.addressList.forEach(ele => {
            if (ele.is_default === 1) {
              this.addressInfo = ele;
              this.address_id = ele.address_id;
            }
          });
          this.listTotal = res.result.total;
        }
      });
    },
    // 地址簿
    lookAddress() {
      this.addressVisible = true;
    },
    // 添加地址
    addAddress() {
      this.addVisible = true;
      this.addTitle = '添加收货地址';
    },
    confirmAdd() {
      if (!this.info.receive_name) {
        this.$message.warning('请输入收货人姓名！');
      } else if (!this.info.receive_mobile) {
        this.$message.warning('请输入收货人电话！');
      } else if (!this.info.province) {
        this.$message.warning('请选择省市区！');
      } else if (!this.info.address) {
        this.$message.warning('请输入详细地址！');
      } else {
        const params = this.info;
        if (this.addTitle == '添加收货地址') {
          api.addAdress(params).then(res => {
            if (res.result) {
              this.$message.success('添加成功！');
              this.native_place = '';
              Object.keys(this.info).forEach(key => (this.info[key] = ''));
              this.getAddressList();
              this.addVisible = false;
            } else {
              this.$message.warning('添加失败！');
            }
          });
        } else {
          api.editAddress(params).then(res => {
            if (res.result) {
              this.$message.success('编辑成功！');
              this.native_place = '';
              Object.keys(this.info).forEach(key => (this.info[key] = ''));
              this.addVisible = false;
              this.getAddressList();
            } else {
              this.$message.warning('编辑失败！');
            }
          });
        }
      }
    },
    // 删除地址
    deleteAddress(item, index) {
      api.deleteAddress({ address_id: item.address_id }).then(res => {
        if (res.result) {
          this.getAddressList();
          this.$message.success('删除成功！');
          this.addressInfo = this.nullAdress;
        } else {
          this.$message.warning('删除失败！');
        }
      });
    },
    // 编辑地址
    editAddress(item) {
      this.info = item;
      this.addTitle = '编辑收货地址';
      this.addVisible = true;
    },
    nativeChange(val) {
      this.info.area = val[2];
      this.info.province = val[0];
      this.info.city = val[1];
    },
    // 选择地址
    selectAddress(item, index) {
      this.addressActive = index;
      this.address_id = item.address_id;
      this.addressVisible = false;
      this.addressInfo = item;
    },
    // 获取省市区街道
    getProvince() {
      api.getProvince().then(res => {
        this.nativeList = res.result;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50PX 0 0;
  margin: 0 auto;
}
.nav-box {
  margin-bottom: 40PX;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.shop-content {
  padding: 32PX 36PX 66PX;
  margin-bottom: 54PX;
  background-color: #ffffff;
}
.address-box {
  // max-height: 300PX;
  overflow: auto;
  margin-bottom: 32PX;
  font-size: 16PX;
  color: #666666;
  line-height: 16PX;
  .icon-box {
    float: left;
    width: 16PX;
    height: 16PX;
    margin-right: 10PX;
    font-size: 12PX;
    line-height: 13PX;
    text-align: center;
    border: 1PX solid #666666;
    border-radius: 2PX;
  }
  span {
    cursor: pointer;
  }
  .address {
    float: right;
    color: #f1a475;
    cursor: pointer;
  }
}
.order-box {
  padding: 0 30PX;
  line-height: 58PX;
  color: #999999;
  background-color: #f5f5f5;
  span {
    padding-left: 65PX;
  }
}
.shop-list-box {
  display: flex;
  padding: 20PX;
  font-size: 16PX;
  border-bottom: 1PX solid #ececec;
  //   justify-content: space-between;
  .shop-img {
    width: 130PX;
    height: 130PX;
    margin-right: 20PX;
    background-color: wheat;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .shop-name {
    width: 32%;
    padding-top: 20PX;
    margin-right: 100PX;
  }
  .shop-price {
    color: #bf0000;
  }
  .shop-type {
    width: 22%;
    padding-top: 30PX;
  }
  .shop-num {
    width: 18%;
    padding-top: 30PX;
  }
  .shop-price {
    padding-top: 30PX;
    text-align: center;
  }
}
.pay-text {
  padding: 26PX 20PX 30PX;
  font-size: 18PX;
  font-weight: bold;
}
.pay-type-box {
  display: flex;
  padding: 0 0 20PX 20PX;
  .type-list {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 28PX;
    margin-right: 42PX;
    font-size: 16PX;
    line-height: 48PX;
    text-align: center;
    border-radius: 7PX;
    border: 1PX solid #cbcbcb;
    cursor: pointer;
    &:hover {
      border-color: #f1a475;
      .active-img {
        display: block;
      }
    }
  }
  .active-type {
    border-color: #f1a475;
    .active-img {
      display: block;
    }
  }
  .active-img {
    position: absolute;
    display: none;
    top: 0;
    right: 0;
    width: 28PX;
    height: 28PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .iconfont-icon {
    padding-right: 14PX;
    font-size: 26PX;
  }
  .icon-weixinfukuan {
    color: #6bcc03;
  }
  .icon-zhifubao {
    color: #189fe4;
  }
  .icon-duigongzhuanzhang {
    color: #faad14;
  }
  .icon-xianjinzhifu {
    color: #f8b551;
  }
}
.bottom-content {
  background-color: #ffffff;
  .bottom-box {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 72%;
    margin: 0 auto;
    padding-left: 40PX;
  }
  .b-flex {
    display: flex;
    // align-items: center;
  }
  .delete-shop {
    padding: 0 46PX 0 60PX;
    color: #898989;
    cursor: pointer;
    &:hover {
      color: #f1a373;
    }
  }
  .clear-shop {
    color: #969696;
    cursor: pointer;
    &:hover {
      color: #f1a373;
    }
  }
  .select-box {
    padding-right: 60PX;
    color: #888888;
    line-height: 88PX;
    span {
      color: #f1a373;
    }
  }
  .price-box {
    padding-right: 36PX;
    color: #888888;
    line-height: 74PX;
    span {
      font-size: 30PX;
      color: #c00c0c;
    }
  }
  .settle-button {
    width: 302PX;
    font-size: 26PX;
    color: #ffffff;
    line-height: 88PX;
    text-align: center;
    background: #f1a475;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
/deep/ {
  .el-radio-group {
    padding-left: 20PX;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #f1a475;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #f1a475;
    background: #f1a475;
  }
  .el-radio__inner:hover {
    border-color: #f1a475;
  }
}
.form-box {
  /deep/ {
    .el-dialog {
      //   height: 610PX;
    }
    .el-dialog__body {
      padding: 0 34PX 40PX;
    }
    .el-input__inner,
    .el-cascader {
      width: 100%;
      height: 30PX;
      line-height: 30PX;
    }
    .el-input__icon {
      line-height: 30PX;
    }
  }
  .form-title {
    margin-bottom: 32PX;
    font-size: 22PX;
    color: #333333;
    font-weight: 500;
    text-align: center;
  }
  .info-list {
    display: flex;
    margin-bottom: 22PX;
    span {
      width: 112PX;
      line-height: 30PX;
      color: #666666;
    }
  }
  .confirm-button {
    width: 176PX;
    height: 44PX;
    margin: 42PX auto 0;
    font-size: 18PX;
    color: #ffffff;
    text-align: center;
    line-height: 44PX;
    background: #f1a475;
    border-radius: 6PX;
    cursor: pointer;
  }
  .text-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .t-text:last-child {
      padding-left: 20PX;
    }
  }
  .first-box {
    margin-bottom: 20PX;
  }
  .t-title {
    width: 50%;
    font-size: 16PX;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-text {
    font-size: 14PX;
    color: #666666;
    line-height: 40PX;
    span {
      font-size: 30PX;
      color: #c00c0c;
    }
  }
  .code-img {
    width: 358PX;
    height: 322PX;
    margin: 0 auto 32PX;
    background-color: #d8d8d8;
    border: 1PX solid #979797;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .have-btn {
    margin-top: 20PX;
  }
  .way-title {
    padding: 40PX 0 12PX;
    margin-bottom: 22PX;
    font-size: 16PX;
    color: #f1a475;
    border-bottom: 1PX solid #e7e7e7;
  }
  .money-box {
    padding: 14PX 8PX;
    background-color: #f6f6f6;
  }
  .money-info {
    padding-bottom: 14PX;
    color: #666666;
    span {
      color: #000000;
    }
  }
  .tip-text {
    padding-bottom: 22PX;
    color: #f90000;
  }
  .submit-button {
    width: 218PX;
    height: 52PX;
    margin: 52PX auto 0;
    font-size: 18PX;
    color: #ffffff;
    text-align: center;
    line-height: 52PX;
    background-color: #f1a373;
    border-radius: 45PX;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

.address-list {
  position: relative;
  padding: 16PX 25PX 12PX 32PX;
  margin-bottom: 16PX;
  background: #ffffff;
  border-radius: 7PX;
  border: 1PX solid #d5d5d5;
  cursor: pointer;
  .l-name {
    padding-bottom: 2PX;
    font-size: 16PX;
    color: #333333;
    span {
      padding-left: 10PX;
    }
  }
  .l-addres {
    padding-bottom: 8PX;
    margin-bottom: 8PX;
    font-size: 14PX;
    color: #666666;
    border-bottom: 1PX solid #d5d5d5;
  }
  .set {
    font-size: 14PX;
    color: #333333;
    cursor: pointer;
    i {
      padding-right: 6PX;
      font-size: 14PX;
    }
  }
  .del-text {
    position: absolute;
    right: 25PX;
    bottom: 12PX;
    font-size: 14PX;
    color: #666666;
    cursor: pointer;
  }
  .el-icon-edit-outline {
    position: absolute;
    right: 25PX;
    top: 16PX;
    font-size: 16PX;
    color: #000000;
    cursor: pointer;
  }
}
.address-active {
  background: #fff5ef;
  border-color: #f1a475;
}
.add-text {
  padding-bottom: 10PX;
  font-size: 16PX;
  color: #f1a475;
  text-align: right;
  cursor: pointer;
}
.address-info {
  padding-bottom: 10PX;
  font-size: 16PX;
  color: #666666;
}

/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    // margin-bottom: 80PX;
    text-align: center;
    // button {
    //   width: 42PX;
    //   height: 42PX;
    // }
  }
  //   .el-pager li {
  //     width: 42PX;
  //     height: 42PX;
  //     line-height: 42PX;
  //   }
}
.quan-content {
  padding: 32PX 0;
  .q-list {
    position: relative;
    display: flex;
    width: 300PX;
    height: 70PX;
    margin-bottom: 22PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f2945a;
    border-radius: 4PX;
    &::before {
      position: absolute;
      left: 40%;
      transform: translateX(-50%);
      top: -5PX;
      width: 15PX;
      height: 15PX;
      border-radius: 50%;
      background-color: #ffffff;
      content: '';
    }
    &::after {
      position: absolute;
      left: 40%;
      transform: translateX(-50%);
      bottom: -5PX;
      width: 15PX;
      height: 15PX;
      border-radius: 50%;
      background-color: #ffffff;
      content: '';
    }
  }

  .price {
    // position: absolute;
    position: relative;
    width: 115PX;
    left: 14PX;
    padding: 0 20PX 0 0;
    margin-right: 50PX;
    font-size: 14PX;
    color: #ffffff;
    line-height: 70PX;
    &::after {
      position: absolute;
      right: 6PX;
      top: 20PX;
      width: 1PX;
      height: 30PX;
      background-color: #ffffff;
      content: '';
    }
    span {
      font-size: 26PX;
      font-weight: bold;
    }
  }
  .text {
    // position: absolute;
    right: 42PX;
    width: 100PX;

    // padding-right: 20PX;
    font-size: 16PX;
    color: #ffffff;
    line-height: 70PX;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .check {
    position: absolute;
    top: 30PX;
    right: -30PX;
  }
  /deep/ {
    .is-checked .el-checkbox__inner {
      background-color: #fb6d0a;
      border-color: #fb6d0a;
    }
    .el-checkbox__inner:hover {
      border-color: #fb6d0a;
    }
  }
}
.no-text {
  padding: 20PX;
}
</style>


// WEBPACK FOOTER //
// src/views/shoppingPay.vue